<script>
  import Animate from '@ui/pico/animate.svelte';
  import Icon from '@ui/pico/icon.svelte';
  import FlipIcon from '@ui/pico/flip-icon.svelte';
  import { createEventDispatcher, onMount } from 'svelte';
  import FeIcon from '../fe-icon.svelte';

  export let add = false;
  export let open = false;
  export let title = '';
  export let icon = '';

  const dispatch = createEventDispatcher();
  let heads = '';
  let tails = '';

  onMount(() => {
    if (!open) {
      heads = 'chevron-right';
      tails = 'chevron-down';
    } else {
      heads = 'chevron-down';
      tails = 'chevron-right';
    }
  });

  function toggleOpen() {
    open = !open;
  }
  function triggerAdd() {
    dispatch('add', { add });
  }
</script>

{#if heads}
  <div class="dztek-accordion">
    <header>
      <p class="title" on:click={toggleOpen} on:keydown={null}>
        <span on:click={toggleOpen} on:keydown={null}>
          {#if icon}
            <Icon name={icon} size={32} />
          {/if}
        </span>
        <slot name="title">
          {title}
        </slot>
      </p>
      <p class="right">
        {#if add}
        <span class="cta">
          <FeIcon name="plus" on:click={triggerAdd} />
        </span>
        {/if}
        <FlipIcon {heads} {tails} on:flip={toggleOpen} size={32} />
      </p>
    </header>
    {#if open}
      <Animate name="fadeIn">
        <div class="content">
          <main>
            <slot name="main" />
          </main>
          <footer>
            <slot name="footer" />
          </footer>
        </div>
      </Animate>
    {/if}
  </div>
{/if}

<style>
  header {
    display: flex;
    justify-content: space-between;
  }
</style>
